/**
 * Page Component
 * 
 * Main page layout combining header, grid, and footer.
 */

import React from 'react';
import { Header } from './Header';
import { RegionGrid } from './RegionGrid';
import { Footer } from './Footer';
import './Page.css';

/**
 * Complete page view with all sections
 * 
 * @param {object} props - Component props
 * @param {object} props.projectData - Parsed project data
 * @param {Array} props.regions - Regions for current page
 * @param {number} props.currentPage - Current page number (1-indexed)
 * @param {number} props.totalPages - Total number of pages
 * @param {boolean} props.canGoNext - Can navigate to next page
 * @param {boolean} props.canGoPrevious - Can navigate to previous page
 * @param {function} props.onNextPage - Next page handler
 * @param {function} props.onPreviousPage - Previous page handler
 * @param {function} props.onUploadClick - Upload button handler
 * @param {function} props.onFileChange - File change handler
 * @param {React.RefObject} props.inputRef - File input ref
 * @param {object} props.touchHandlers - Touch gesture handlers
 */
export function Page({
  projectData,
  regions,
  currentPage,
  totalPages,
  canGoNext,
  canGoPrevious,
  onNextPage,
  onPreviousPage,
  onUploadClick,
  onFileChange,
  inputRef,
  touchHandlers,
}) {
  return (
    <div
      className="page"
      {...touchHandlers}
    >
      <Header
        songName={projectData.songName}
        songId={projectData.songId}
        musicianName={projectData.musicianName}
        bpm={projectData.bpm}
        timeSignature={projectData.timeSignature}
        musicKey={projectData.musicKey}
        onUploadClick={onUploadClick}
        onFileChange={onFileChange}
        inputRef={inputRef}
      />
      
      <RegionGrid
        regions={regions}
        currentPage={currentPage}
      />
      
      <Footer
        currentPage={currentPage}
        totalPages={totalPages}
        canGoNext={canGoNext}
        canGoPrevious={canGoPrevious}
        onNextPage={onNextPage}
        onPreviousPage={onPreviousPage}
      />
    </div>
  );
}


